module["exports"] = [
  "읍",
  "면",
  "동"
];
